type floorFormatType = 10 | 100 | 1000 | 10000 | 100000 | 1000000 | 10000000

export const useDisplayNumber = () => {
    const floorBalance = (initNumber: number, format: floorFormatType = 100, showCurrent = true, unit?: string) => {
        if (unit) {
            const value = Math.floor(initNumber * format) / format

            if (value < 0) {
                return '-' + unit + Math.abs(value)
            }
            return unit + value.toLocaleString('ko-KR', {maximumFractionDigits: 5})
        }
        return (
            (Math.floor(initNumber * format) / format).toLocaleString('ko-KR', {maximumFractionDigits: 5}) +
            (showCurrent ? ' USD' : '')
        )
    }

    const renderPercent = (number: number, format: floorFormatType = 10) => {
        return (Math.floor(number * format) / format).toLocaleString() + '%'
    }

    const displayAmount = (amount: number, price: number = 100): string => {
        if (!amount) return '0'

        return (Math.floor(amount * price) / price).toLocaleString('ko-KR', {maximumFractionDigits: 7})
    }

    const toFixedNumber = (number: number, toFixed: number = 3): string => {
        if (number === 0) {
            return '0'
        }
        return number.toFixed(toFixed).toLocaleString()
    }

    return {floorBalance, renderPercent, displayAmount, toFixedNumber}
}
